import {
  BuyCreditsButton,
  SimulationCreditsBadge,
  useSimulationGate,
} from "@/components/billing/simulation-gate";

/** Balance strip for the simulation hub: shows credits and the ₹29 top-up. */
export function CreditsSummary({ className = "" }: { className?: string }) {
  const { state, checking } = useSimulationGate();
  if (checking || !state?.signedIn || state.isGuest) return null;

  return (
    <div
      className={`glass flex flex-wrap items-center justify-between gap-3 rounded-2xl px-4 py-3 ${className}`}
    >
      <div>
        <SimulationCreditsBadge balance={state.balance} />
        {state.balance <= 0 ? (
          <p className="mt-2 text-[11px] text-muted-foreground">
            You&apos;ve used all your simulation credits.
          </p>
        ) : null}
      </div>
      {state.balance <= 0 || state.canBuyAddon ? (
        <BuyCreditsButton addonPaise={state.addonPaise} canBuyAddon={state.canBuyAddon} />
      ) : null}
    </div>
  );
}
